import { t } from 'i18next';
import { createFilter } from "../../components/Tables/ColumnCreationHelper";
import { AppTableFilters } from '../../services/AppTableFilters';
import { IOrganizationTour } from '../../types/models/OrganizationTour';

export const appTableFiltersInstance = new AppTableFilters();

export const toursTableColumns = (data: IOrganizationTour[]) => [
  {
    id: 'id',
    Header: t('table.id'),
    accessor: 'id',
    maxWidth: 100,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'id', t('table.id'))
  },
  {
    id: 'name',
    Header: t('table.name'),
    accessor: 'name',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'name', t('table.name'))
  },
  {
    id: 'externalId',
    Header: t('table.externalId'),
    accessor: 'externalId',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'externalId', t('table.externalId'))
  },
  {
    id: "isAssigned",
    Header: t('table.isAssigned'),
    accessor: "isAssigned",
    maxWidth: 50,
    filter: createFilter(
      appTableFiltersInstance,
      'radio',
      "isAssigned",
      t('table.isAssigned'),
      [
        { value: 'yes', label: t('common.yes') },
        { value: 'no', label: t('common.no') }
      ],
      (item, value) => {
        if (value === 'yes') {
          return item.isAssigned;
        }
        return !item.isAssigned;
      }
    )
  }
];
